export default __webpack_public_path__ + "static/media/remove.9f93c3c8.svg";